/* Avoid native lazy loading's large prefetch range on the homepage. */
(() => {
  function start() {
    const images = document.querySelectorAll('img[data-bm-deferred-image]');
    function load(image) {
      const picture = image.closest('picture');
      picture?.querySelectorAll('source[data-srcset]').forEach(source => {
        source.srcset = source.dataset.srcset;
      });
      image.loading = 'eager';
      if (image.dataset.srcset) image.srcset = image.dataset.srcset;
      if (image.dataset.src) image.src = image.dataset.src;
      image.removeAttribute('data-bm-deferred-image');
    }
    if (!('IntersectionObserver' in window)) {
      images.forEach(load);
      return;
    }
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        load(entry.target);
      });
    }, { rootMargin: '400px' });
    images.forEach(image => observer.observe(image));
  }
  const styles = document.querySelector('link[data-href*="/bm-home-component-styles.css"]');
  if (!styles || styles.media === 'all') start();
  else {
    const ready = () => requestAnimationFrame(start);
    styles.addEventListener('load', ready, { once: true });
    styles.addEventListener('error', ready, { once: true });
  }
})();
